import { CdkDrag, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { ColorPickerModule } from 'ngx-color-picker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { CommonsModule } from 'app/commons/commons.module';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';

import { SocialModule } from '../social/social.module';

import { HomeButtonComponent } from './components/home-button/home-button.component';
import { ModalColorPickerComponent } from './components/modal-color-picker/modal-color-picker.component';
import { ModalCreateItemComponent } from './components/modal-create-item/modal-create-item.component';
import { ModalUploadFileComponent } from './components/modal-upload-file/modal-upload-file.component';
import { ModalUploadImageComponent } from './components/modal-upload-image/modal-upload-image.component';
import { RoomBackgroundCardComponent } from './components/room-background-card/room-background-card.component';
import { RoomInfoPreviewComponent } from './components/room-info-preview/room-info-preview.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { BackgroundCardComponent } from './pages/create-room/background-card/background-card.component';
import { ConfirmCardComponent } from './pages/create-room/confirm-card/confirm-card.component';
import { CreateRoomPageComponent } from './pages/create-room/create-room-page.component';
import { MusicCardComponent } from './pages/create-room/music-card/music-card.component';
import { NameCardComponent } from './pages/create-room/name-card/name-card.component';
import { RoomSizeComponent } from './pages/create-room/room-size-card/room-size-card.component';
import { EditRoomPageComponent } from './pages/edit-room/edit-room-page.component';
import { PixiItemEditorComponent } from './pages/pixi-item-editor/pixi-item-editor.component';
import { CustomComponent } from './scootaverse-badging/custom/custom.component';
import { OverviewComponent } from './scootaverse-badging/overview/overview.component';
import { QuestionsComponent } from './scootaverse-badging/questions/questions.component';
import { ScootaverseBadgingComponent } from './scootaverse-badging/scootaverse-badging.component';
import { VisualIndicatorComponent } from './scootaverse-badging/visual-indicator/visual-indicator.component';
import { ShowMoreItemsDirective } from './scootaverse-entry-flows/badges-directive';
import { EntryFlowApplyRoomsComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-apply-rooms/entry-flow-apply-rooms.component';
import { EntryFlowCardComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-card/entry-flow-card.component';
import { EntryFlowDefaultInfoComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-default-info/entry-flow-default-info.component';
import { EntryFlowDetailsComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-details.component';
import { EntryFlowGroupFormerComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-group-former/entry-flow-group-former.component';
import { GroupFormerOptionComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-group-former/group-former-option/group-former-option.component';
import { EntryFlowPreviewComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-preview/entry-flow-preview.component';
import { EntryFlowsComponent } from './scootaverse-entry-flows/entry-flows.component';
import { ScootaversePageComponent } from './scootaverse-page/scootaverse-page.component';
import { CreateRoomComponent } from './scootaverse-rooms/create-room/create-room.component';
import { NoRoomsPageComponent } from './scootaverse-rooms/no-rooms.component';
import { RoomAdvancedSettingsComponent } from './scootaverse-rooms/room-settings/advanced-settings/room-advanced-settings.component';
import { RoomSettingsComponent } from './scootaverse-rooms/room-settings/room-settings.component';
import { ScootaverseRoomsComponent } from './scootaverse-rooms/scootaverse-rooms.component';
import { ScootaverseRoutingModule } from './scootaverse-routing.module';
import { ScootaverseSettingsPageComponent } from './scootaverse-settings-page/scootaverse-settings-page.component';
import { CreateScootaverseComponent } from './scootaverses/create-scootaverse/create-scootaverse.component';
import { ModalScootaversesComponent } from './scootaverses/modal-scootaverses/modal-scootaverses.component';
import { NoScootaversesPageComponent } from './scootaverses/no-scootaverses.component';
import { ScootaverseCardComponent } from './scootaverses/scootaverse-card/scootaverse-card.component';
import { ScootaversesComponent } from './scootaverses/scootaverses.component';
import { ScootaverseEditService } from './services/scootaverse-edit.service';
import { ScootaversePageService } from './services/scootaverse-page.service';
import { ScootaverseRoutingService } from './services/scootaverse-routing.service';
import { ScootaversePageEffects } from './state/effects';
import { EventCountdownPageComponent } from '../social-events/pages/event-countdown/event-countdown-page.component';
import { ModalButtonStyleComponent } from './components/modal-button-style/modal-button-style.component';

@NgModule({
  declarations: [
    ScootaversePageComponent,
    ScootaversesComponent,
    ScootaverseRoomsComponent,
    NoScootaversesPageComponent,
    ModalScootaversesComponent,
    NoRoomsPageComponent,
    PageHeaderComponent,
    ScootaverseCardComponent,
    CreateScootaverseComponent,
    CreateRoomComponent,
    RoomSettingsComponent,
    RoomAdvancedSettingsComponent,
    QuestionsComponent,
    ScootaverseBadgingComponent,
    CustomComponent,
    VisualIndicatorComponent,
    OverviewComponent,
    CreateRoomPageComponent,
    NameCardComponent,
    MusicCardComponent,
    RoomSizeComponent,
    RoomBackgroundCardComponent,
    BackgroundCardComponent,
    ConfirmCardComponent,
    ModalColorPickerComponent,
    ModalButtonStyleComponent,
    ScootaverseSettingsPageComponent,
    ModalUploadImageComponent,
    EntryFlowsComponent,
    ShowMoreItemsDirective,
    EntryFlowDetailsComponent,
    EntryFlowGroupFormerComponent,
    EntryFlowDefaultInfoComponent,
    EntryFlowCardComponent,
    EntryFlowPreviewComponent,
    EntryFlowApplyRoomsComponent,
    GroupFormerOptionComponent,
    RoomInfoPreviewComponent,
    EditRoomPageComponent,
    ModalUploadFileComponent,
    ModalCreateItemComponent,
  ],
  providers: [ScootaversePageService, ScootaverseRoutingService, ScootaverseEditService],
  exports: [ModalScootaversesComponent, ScootaverseCardComponent],
  imports: [
    CoreModule,
    SocialModule,
    CommonModule,
    CommonsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ScootaverseRoutingModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressBarModule,
    MatRadioModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatMenuModule,
    MatSidenavModule,
    MatButtonModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatDividerModule,
    MatInputModule,
    MatExpansionModule,
    MatTabsModule,
    MatStepperModule,
    MatChipsModule,
    InfiniteScrollModule,
    MatProgressSpinnerModule,
    EffectsModule.forFeature([ScootaversePageEffects]),
    ColorPickerModule,
    HomeButtonComponent,
    MatButtonToggleModule,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    MatTableModule,
    PixiItemEditorComponent,
    ImageCropperModule,
  ],
})
export class ScootaverseModule {}
